export async function useFetchConfiguration() {
  const { data: config } = await useFetch<Config>('/api/configuration', {
    baseURL: useRuntimeConfig().public.cms,
    query: {
      populate: 'deep',
    },
    key: 'dbc-config',
    onResponse({ response }) {
      response._data = response._data.data
      response._data = normalizeConfig(response._data)
      return response._data
    },
  })
  return config
}

const normalizeConfig = (data: any | null): Config => ({
  id: data?.id,
  client: data?.clientId,
  customerServicePhoneNumber: data?.customer_service_phone_number,
  project: data?.deploy_project,
  env: data?.deploy_env,
  logo: data?.logo,
})
